export const DataHooks_o = {

    // page creator event item 
    page_creator_event_item_root: "page-creator-event-item-root",
    page_creator_event_basic_info: "basic_info",
    page_creator_event_item_media_button: "media-button",

    // page quest event media 
    page_quest_event_media_root: "page-quest-event-media-root",
    page_quest_event_media_download_btn: "download-btn",
    page_quest_event_media_choose_file: "choose-file",
    page_quest_event_media_choose_team_files: "choose-team-files",
    page_quest_event_media_file: "file",
    page_quest_event_media_counter: "counter",

    // page profile 
    page_player_profile: 'page_player_profile',

    // comp tabs
    tq_tabs: "tq-tabs",

    // === components ===

    // comp login
    comp_login: 'comp_login',
    login_with_email_btn: 'login_with_email_btn',
    login_with_email_continue_btn: 'login_with_email_continue_btn',
    login_with_email_input_email: 'login_with_email_input_email',
    login_with_email_input_password: 'login_with_email_input_password',
    login_with_gmail_btn: 'login_with_gmail_btn',
    login_with_facebook_btn: 'login_with_facebook_btn',

    // comp profile
    comp_profile: 'comp_profile',
    comp_profile_email: 'comp_profile_email',
    comp_profile_logout: 'comp_profile_logout',

    // comp btn
    comp_btn_approved_btn: "comp_btn_approved_btn",
    comp_btn_approved_main: "comp_btn_approved_main",

    // comp notification 
    notification_root: "notification-root",
    notification_item: "notification-item",


}